import request from './request'

// 8001 用户中心服务统一前缀：与后端 /api/v1/user_service/ 路由保持一致
const USER_API_PREFIX = '/api/v1/user_service'

export const userApi = {
  getProfile() { return request.get(`${USER_API_PREFIX}/users/me`) },
  updateProfile(data) { return request.put(`${USER_API_PREFIX}/users/me`, data) },
  changePassword(data) { return request.post(`${USER_API_PREFIX}/users/me/password`, data) },
  listUsers(params = {}) { return request.get(`${USER_API_PREFIX}/users/`, { params }) },
  listIndependentUsers(params = {}) { return request.get(`${USER_API_PREFIX}/users/independent/`, { params, silent: true }) },
  getTokenQuotaSummary(params = {}) { return request.get(`${USER_API_PREFIX}/users/token-quota/summary`, { params }) },
  createUser(data) { return request.post(`${USER_API_PREFIX}/users/`, data) },
  linkIndependentUsers(data) { return request.post(`${USER_API_PREFIX}/users/link-independent/`, data, { silent: true }) },
  updateUser(userId, data) { return request.put(`${USER_API_PREFIX}/users/${userId}`, data) },
  deleteUser(userId) { return request.delete(`${USER_API_PREFIX}/users/${userId}`) },
  exitAdministrator() { return request.post(`${USER_API_PREFIX}/users/me/exit-administrator`) },
  exitEnterprise(userId) { return request.post(`${USER_API_PREFIX}/users/exit-enterprise/${userId}`) },
  setEnterpriseAdmin(userId) { return request.post(`${USER_API_PREFIX}/users/set-enterprise-admin/${userId}`) },
  searchByIdentity(keyword) { return request.get(`${USER_API_PREFIX}/users/search-by-identity/`, { params: { keyword } }) }
}
